import React from "react"

const Overlay = () => {
  return (
    <section data-scroll-section className="overlay">
      <div className="overlay-f"></div>
      <div data-scroll data-scroll-speed="1.5" className="overlay-h">
        <div className="wrapper overlay-w">
          <div className="overlay-content">
            <h1 className="title-md">Eruption in style</h1>
            <p>
              Dallol like the volcano is a shoe store created and produced by
              Loord and our friends from Scorpion squad, Jump into the eruption
              to renew and replenish your wardrobe.
            </p>
            <button className="btn-cta">More About us</button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Overlay
